import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { devtools } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// services
import { initializeService } from '../services/initializeService'

// types
import { InitializeData } from '../types/initializeTypes'
type Store = {
  initializeData: InitializeData
  loading: boolean
  error: string | null
  errorCode: string | null
  clearData: () => void
  initialize: (store) => void
}

const useInitializeStore = create(
  devtools<Store>((set) => ({
    initializeData: null,
    loading: false,
    error: null,
    errorCode: null,
    clearData: () =>
      set({
        initializeData: null,
        loading: false,
        error: null,
        errorCode: null
      }),
    initialize: async (store=null) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _initializeData = await initializeService.initialize(store)
        set((state) => ({ ...state, initializeData: _initializeData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message, errorCode: err.code }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useInitializeStore }
